import React, { createContext, PropsWithChildren, useContext, useMemo } from "react";
import { CorePackagesCheckout, CorePackagesCheckoutV2 } from "redmond";

interface CorePackagesNavigationCallbacks {
  goToSearch?: () => void;
  goToHotelAvailability?: () => void;
  goToHotelShop?: () => void;
  goToFlightShopOutbound?: () => void;
  goToFlightShopReturn?: () => void;
}

const CorePackagesNavigationContext =
  createContext<CorePackagesNavigationCallbacks>({});

interface CorePackagesNavigationProviderProps {
  core?: CorePackagesCheckout;
  coreV2?: CorePackagesCheckoutV2;
}

export const CorePackagesNavigationProvider = ({
  core,
  coreV2,
  children,
}: PropsWithChildren<CorePackagesNavigationProviderProps>) => {
  const value = useMemo<CorePackagesNavigationCallbacks>(
    () => ({
      goToSearch: core?.goToSearch,
      goToHotelAvailability:
        core?.goToHotelAvailability ?? coreV2?.goToHotelAvailability,
      goToHotelShop: core?.goToHotelShop ?? coreV2?.goToHotelShop,
      goToFlightShopOutbound:
        core?.goToFlightShopOutbound ?? coreV2?.goToFlightShopOutbound,
      goToFlightShopReturn:
        core?.goToFlightShopReturn ?? coreV2?.goToFlightShopReturn,
    }),
    [core, coreV2]
  );

  return (
    <CorePackagesNavigationContext.Provider value={value}>
      {children}
    </CorePackagesNavigationContext.Provider>
  );
};

export const useCorePackagesNavigation = () =>
  useContext(CorePackagesNavigationContext);
